import { render, staticRenderFns } from "./AccountForcedPasswordChange.vue?vue&type=template&id=674176e2&scoped=true&"
import script from "./AccountForcedPasswordChange.vue?vue&type=script&lang=js&"
export * from "./AccountForcedPasswordChange.vue?vue&type=script&lang=js&"
import style0 from "./AccountForcedPasswordChange.vue?vue&type=style&index=0&id=674176e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674176e2",
  null
  
)

export default component.exports